/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { DocumentDownloadDto } from '../../models/document-download-dto';

export interface GetSurveyPlanPdf$Params {
  survey_label: string;
}

export function getSurveyPlanPdf(
  http: HttpClient,
  rootUrl: string,
  params: GetSurveyPlanPdf$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<DocumentDownloadDto>> {
  const rb = new RequestBuilder(rootUrl, getSurveyPlanPdf.PATH, 'get');
  if (params) {
    rb.query('survey_label', params.survey_label, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DocumentDownloadDto>;
      }),
    );
}

getSurveyPlanPdf.PATH = '/document/surveyPlan';
